import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TaskStatus, Priority } from '../types';
import { translateStatus, translatePriority } from '../utils/enumTranslation';

export const useFilterState = () => {
  const { t } = useTranslation();

  const getStatusLabel = useCallback(
    (status: TaskStatus): string => translateStatus(status, t),
    [t]
  );

  const getPriorityLabel = useCallback(
    (priority: Priority): string => translatePriority(priority, t),
    [t]
  );

  const getStatusData = useCallback(
    () =>
      Object.values(TaskStatus).map((status) => ({
        value: status,
        label: getStatusLabel(status),
      })),
    [getStatusLabel]
  );

  const getPriorityData = useCallback(
    () =>
      Object.values(Priority).map((priority) => ({
        value: priority,
        label: getPriorityLabel(priority),
      })),
    [getPriorityLabel]
  );

  const getActiveFilterCount = useCallback(
    (statusFilter: TaskStatus[], priorityFilter: Priority[]): number => {
      return statusFilter.length + priorityFilter.length;
    },
    []
  );

  return {
    getStatusLabel,
    getPriorityLabel,
    getStatusData,
    getPriorityData,
    getActiveFilterCount,
  };
};
